import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { signOut } from "../utils/auth/sessionUtilities";

const Logout: React.FC = () => {
	const [done, setDone] = useState(false);

	useEffect(() => {
		// identity clears the HttpOnly cookies and revokes the session; signOut ends this tab's state even if that call fails.
		void signOut().finally(() => {
			localStorage.clear();
			setDone(true);
		});
	}, []);

	return done ? <Navigate to="/login" replace /> : null;
};

export default Logout;
